<template>
	<v-layout row wrap>
	<table
		:class="[
			'table-list',
		]"
		border="0"
		cellpadding="0"
		cellspacing="0"
	>
		<thead>
			<tr v-if="inputSearch || filterColumns || deleteSeat || includeFilter || addButton || editCont">
				<th :colspan="totalVisibleColumns" :class="[`text-xs-${direction}`, 'movil-header-row']">
					<v-flex  xs12  v-if="flagTitle">
				<v-layout wrap align-center justify-center class="should-color">
					<v-flex>
						<div font-weight-bold class="d-flex px-0 justify-center">
							<span class="debitV">{{ title }}</span>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
					<button
						class="vertical-align-middle btn-clean-filter no-movil"
						v-if="clearFilter"
						type="button"
						@click="tableClearFilter">
						Limpiar Filtro
					</button>
					<button
						class="vertical-align-middle btn-filter no-movil"
						v-if="includeFilter"
						type="button"
						@click="tableOption">
					 Filtros
					</button>
					<v-menu
	offset-y
	:nudge-left="200"
	max-height="400"
	fixed
	v-model="showMenu"
	v-if="filterColumns"
	:close-on-content-click="false">
	<button slot="activator" title="Mostrar u ocultar columnas">
		<v-icon>view_column</v-icon>
	</button>

	<div :style="ui.panel">
		<div :style="ui.head">
			<span :style="ui.title">Mostrar columnas</span>
			<span :style="ui.count">{{ checkedColumnsCount }} / {{ selectableColumnsCount }}</span>
		</div>

		<div :style="ui.list">
			<template v-for="column in columns">
				<label
					v-if="!column.flagVisible"
					:key="column.id"
					:style="optionStyle(column)"
					@mouseenter="hoverKey = 'col-' + column.id"
					@mouseleave="hoverKey = ''">
					<input type="checkbox" v-model="column.checked" :style="ui.hidden">
					<span :style="boxStyle(column)">&#10003;</span>
					<span :style="nameStyle(column)">{{ column.name }}</span>
				</label>
			</template>
		</div>

		<div :style="ui.foot">
			<button
				type="button"
				:style="ghostButtonStyle"
				@mouseenter="hoverKey = 'all'"
				@mouseleave="hoverKey = ''"
				@click="toggleAllColumns">
				Todas
			</button>
			<button
				type="button"
				:style="mainButtonStyle"
				@mouseenter="hoverKey = 'apply'"
				@mouseleave="hoverKey = ''"
				@click="toggleColumns">
				Aplicar
			</button>
		</div>
	</div>
</v-menu>
					<v-tooltip top>
						<v-btn
							v-if="downButton"
							slot="activator"
							color="success"
							class="btn-auto pa-0 ma-2"
							@click="$emit('download-format')">
							<v-icon color="white">download</v-icon>
						</v-btn>
						<span>Descargar Formato</span>
					</v-tooltip>
					<v-tooltip top>
						<v-btn
							v-if="showExcel"
							slot="activator"
							color="success"
							class="btn-auto pa-0 ma-2"
							@click="$emit('import-excel')">
							<img :src="'static/img/icons/excel.svg'" alt="import_excel" :height="height">
						</v-btn>
						<span>Cargar Excel</span>
					</v-tooltip>
					<v-btn
						target="_blank"
						:disabled="disabledEditAccou"
						v-if="editCont"
						color="blue"
						class="btn-edit"
						@click="$emit('edit-accouting')"
					>
						Editar
					</v-btn>
					<v-tooltip top>
						<v-btn
							slot="activator"
							color="red"
							v-if="deleteSeat"
							class="btn-auto pa-0 ma-2 btn-delete"
							type="button"
							@click="openDeleteSeat"
							>
							<v-icon color="white" size="19">
								delete
							</v-icon>
						</v-btn>
						<span>{{ tooltipDelete }}</span>
					</v-tooltip>
					<v-tooltip top>
						<v-btn
							slot="activator"
							@click="addAIconAction"
							v-if="addIcon"
							class="vertical-align-middle pa-0 ma-0 btn-clean-filter-add btn-add no-movil"
							type="button">
							<div class="vertical-align-middle" style="font-size: 10px; font-weight: 600; color: white; margin-right: 5px">
							Nuevo Asiento
							</div>
							<v-icon color="white" size="19">add</v-icon>
						</v-btn>
						<span>{{ nameTooltip }}</span>
					</v-tooltip>
					<slot name="text"></slot>
					<button
						v-if="addButton"
						type="button"
						@click="addOption">
						<v-icon>add</v-icon>
					</button>
					<div class="search-input" v-if="inputSearch">
						<input
							type="text"
							v-model="search"
							@keyup.enter="searchRows"
							@keyup.esc="searchRows"
						>
						<v-icon>search</v-icon>
					</div>
				</th>
			</tr>
			<tr class="movil-table">
				<th
					v-if="selectable"
					:class="{ 'hide-selectable-on-movil': hideSelectableOnMovil }"
				>
					<input
						type="checkbox"
						:value="checkAll"
						:checked="checkAll"
						class="input-checkbox"
						@change="selectedAll($event)">
				</th>
				<th
					is="table-column-item"
					v-for="column in columns"
					:key="column.id"
				  	:column="column"
					v-show="column.visible"
					:class="[
						'text-xs-center',
						{ 'column-movil-version': !column.movil },
					]"
				>
				</th>
				<!--  <th class="absolute-btn" v-if="createdAdd || $route.name === 'journal'"> !-->
				<th class="absolute-btn" v-if="$route.name === 'center-of-cost' || $route.name === 'journal'">
					<button
					slot="activator"
					@click="createAction"
					class="btn-add-mobile">
						<img src="/static/img/icons/plus.svg" alt="" width="17" height="17">
					</button>
				</th>
			</tr>
		</thead>
		<tbody>
			<template>
				<tr v-for="(row, index) in rows"
					:key="row[keyValue]"
					:class="[
						{ 'row-checked' : row.isSelected || row.isVisited },
						'movil-table',
					]"
					@click="rowIsSelected(row)"
				>
					<td
						v-if="selectable"
						class="check-row"
						:class="{ 'hide-selectable-on-movil': hideSelectableOnMovil }"
					>
						<input
							type="checkbox"
							v-model="row.isSelected"
							class="input-checkbox"
							:disabled="dispatchDetail && (row.flagDispatch > 0)">
					</td>
					<slot name="rows" :index="index" :row="row"></slot>
				</tr>
			</template>
		</tbody>
		<tfoot class="table-pagination" v-if="tFoot">
			<tr v-if="mainList && rows.length > 0">
				<td :colspan="totalVisibleColumns" class="text-xs-right">
					<template v-if="numberSeats">
						<span class="mr-5 pr-5" v-if="numberSeats > 0"># Asientos: {{ numberSeats }}</span>
					</template>
					<template v-if="captionQuantity">
							<span class="caption-quantity pr-2">{{ itemsQuantity }} <span v-if="captionQuantity">de</span> {{ itemsTotalQuantity }}</span>
						</template>
					<input
						type="text"
						@input="selectPage($event.target.value)"
						:value="currentPage"
						class="search-input unique-input">
					<a
						v-for="(page, index) in pages"
						:key="index"
						:class="{ 'active-page': page === currentPage }"
						@click="selectPage(page)">{{page}}</a>
					<span>|</span>
					<a @click="selectLastPage">>></a>
				</td>
			</tr>
			<tr v-if="rows.length === 0">
				<td v-if="showAccounting"
				:colspan="totalVisibleColumns"
				:style="!mainList ?
						'border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;' :
						'border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;'">
					<p style="text-align:center; margin: 150px 0 150px 0;color: #a9bac2;font-weight: 600;">
						Selecciona un registro y contabiliza para que aparezcan los asientos
					</p>
				</td>
				<td class="td-record" :colspan="totalVisibleColumns" v-else-if="showRecord">
					<p class="show-record">
						Seleccione un modulo para visualizar información
					</p>
				</td>
				<td v-else :colspan="totalVisibleColumns"
					:style="!mainList ?
						'border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;' :
						'border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;'">
					<p style="text-align:center; margin: 5px 0 0 5px">
						No hay información que mostrar
					</p>
				</td>
			</tr>
		</tfoot>
	</table>
</v-layout>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import TableColumnItem from './table-column-item';
import helper from './../../../shared/helper';

const ADD_REQUEST_EVENT = 'on-add-event';
const LOCAL_SEARCH_EVENT = 'on-local-search';
const SEARCH_EVENT = 'on-search-event';
const ON_DRAG_EVENT = 'on-drag-event';
const ON_DRAG_ENTER = 'on-drag-enter';
const ON_DRAG_LEAVE = 'on-drag-leave';
const ON_DROP_EVENT = 'on-drop-event';
const ON_PAGE_EVENT = 'on-page';
const ROW_IS_SELECTED = 'row-is-selected';
const ROW_ON_CLICK = 'row-on-click';
const SELECTED_ALL_EVENT = 'on-selected-all';
const TABLE_OPTION_EVENT = 'table-option-event';
const TABLE_CLEAR_FILTER = 'clear-filter';

const components = {
	TableColumnItem,
	appTooltipButton,
};

function addOption() {
	this.$emit(ADD_REQUEST_EVENT);
}

function addAIconAction() {
	this.$emit('add-icon');
}

function pagination(pageNumber, totalRecords) {
	const current = pageNumber;
	const last = totalRecords;
	const delta = 2;
	const left = current - delta;
	const right = current + delta + 1;
	const range = [];
	const rangeWithDots = [];
	let l = null;

	for (let i = 1; i <= last; i += 1) {
		/* eslint-disable no-mixed-operators */
		if (i === 1 || i === last || i >= left && i < right) {
			range.push(i);
		}
	}

	/* eslint-disable no-restricted-syntax */
	for (const i of range) {
		if (l) {
			if (i - l === 2) {
				rangeWithDots.push(l + 1);
			} else if (i - l !== 1) {
				rangeWithDots.push('...');
			}
		}
		rangeWithDots.push(i);
		l = i;
	}

	return rangeWithDots;
}

function data() {
	return {
		direction: 'right',
		search: '',
		showMenu: false,
		hoverKey: '',
		ui: {
			panel: {
				background: '#ffffff',
				borderRadius: '2px',
				overflow: 'hidden',
				width: '238px',
			},
			head: {
				alignItems: 'center',
				background: '#f4f7f8',
				borderBottom: '1px solid #e3e9ec',
				display: 'flex',
				justifyContent: 'space-between',
				padding: '9px 14px',
			},
			title: {
				color: '#5b6b76',
				fontSize: '10px',
				fontWeight: '700',
				letterSpacing: '0.9px',
				textTransform: 'uppercase',
			},
			count: {
				color: '#90a0aa',
				fontSize: '10.5px',
				fontWeight: '700',
			},
			list: {
				maxHeight: '260px',
				overflowY: 'auto',
				padding: '4px',
			},
			option: {
				alignItems: 'center',
				borderRadius: '8px',
				cursor: 'pointer',
				display: 'flex',
				margin: '0',
				padding: '7px 10px',
				userSelect: 'none',
			},
			hidden: {
				display: 'none',
			},
			box: {
				alignItems: 'center',
				borderRadius: '5px',
				display: 'flex',
				flex: '0 0 16px',
				fontSize: '11px',
				fontWeight: '900',
				height: '16px',
				justifyContent: 'center',
				lineHeight: '1',
				marginRight: '9px',
				width: '16px',
			},
			name: {
				fontSize: '12.5px',
				fontWeight: '600',
			},
			foot: {
				borderTop: '1px solid #e3e9ec',
				display: 'flex',
				padding: '10px',
			},
			button: {
				borderRadius: '8px',
				cursor: 'pointer',
				fontFamily: 'inherit',
				fontSize: '12px',
				fontWeight: '700',
				height: '32px',
			},
		},
	};
}
function checkedColumnsCount() {
	return this.columns.filter(c => !c.flagVisible && c.checked).length;
}

function selectableColumnsCount() {
	return this.columns.filter(c => !c.flagVisible).length;
}

function ghostButtonStyle() {
	return Object.assign({}, this.ui.button, {
		background: this.hoverKey === 'all' ? '#f4f7f8' : '#ffffff',
		border: '1px solid #e3e9ec',
		color: '#5b6b76',
		flex: '0 0 auto',
		padding: '0 14px',
	});
}

function mainButtonStyle() {
	return Object.assign({}, this.ui.button, {
		background: this.hoverKey === 'apply' ? '#017e82' : '#02979b',
		border: '0',
		color: '#ffffff',
		flex: '1',
		marginLeft: '8px',
	});
}

function optionStyle(column) {
	let background = 'transparent';
	if (column.checked) {
		background = '#e8f5f5';
	} else if (this.hoverKey === `col-${column.id}`) {
		background = '#f4f7f8';
	}
	return Object.assign({}, this.ui.option, { background });
}

function boxStyle(column) {
	return Object.assign({}, this.ui.box, {
		background: column.checked ? '#02979b' : '#ffffff',
		border: column.checked ? '1.5px solid #02979b' : '1.5px solid #cfd8dd',
		color: column.checked ? '#ffffff' : 'transparent',
	});
}

function nameStyle(column) {
	return Object.assign({}, this.ui.name, {
		color: column.checked ? '#16222b' : '#3d4b55',
	});
}

function toggleAllColumns() {
	const allChecked = this.columns
		.filter(c => !c.flagVisible)
		.every(c => c.checked);
	this.columns.forEach((col) => {
		const newCol = col;
		if (!newCol.flagVisible) {
			newCol.checked = !allChecked;
		}
	});
}
function created() {
	console.log('this.route.name::: ', this.$route.name);
	if (this.$route.name === 'ledger') {
		this.search = this.accountName;
		const key = {
			keyCode: 13,
		};
		this.searchRows(key);
	}
}
function mounted() {
	window.addEventListener('resize', this.optionsDirection);
	this.optionsDirection();
	const columnsInLocalStorage = helper.getLocalData(`${this.$attrs.name}::columns`);
	if (columnsInLocalStorage) {
		this.columns.forEach((col) => {
			const newCol = col;
			const colToChange = columnsInLocalStorage.find(c => c.id === newCol.id);
			if (colToChange) {
				newCol.visible = colToChange.visible;
				newCol.checked = colToChange.checked;
			}
		});
	}
	if (this.localStorage) {
		const searchFromLocalStorage = helper.getLocalData(`${this.$attrs.name}::search`);
		if (searchFromLocalStorage) {
			this.search = searchFromLocalStorage;
			this.$emit(SEARCH_EVENT, searchFromLocalStorage);
		}
	}
}

function toggleColumns() {
	this.selectedColumns = this.columns.filter(c => !c.checked);
	this.columns.forEach((col) => {
		const newCol = col;
		const colToChange = this.selectedColumns.find(c => c.id === newCol.id);
		newCol.visible = typeof colToChange === 'undefined';
	});
	helper.setLocalData(`${this.$attrs.name}::columns`, this.selectedColumns);
	this.showMenu = false;
}

function selectedAll({ target }) {
	this.$emit(SELECTED_ALL_EVENT, target.checked);
}

function rowIsSelected(row) {
	if (this.selectable) {
		this.$set(row, 'isSelected', !row.isSelected);
		this.$emit(ROW_IS_SELECTED, row);
	} else {
		this.$emit(ROW_ON_CLICK, row);
	}
}

function searchRows($event) {
	console.log('$event::: ', $event);
	const keyCode = $event.keyCode;
	console.log('keyCode::: ', keyCode);
	if (keyCode === 27) {
		this.search = '';
	}
	if (this.localSearch) {
		const dataToLocalSearch = this.search.toLowerCase();
		helper.setLocalData(`${this.$attrs.name}::search`, dataToLocalSearch);
		this.$emit(LOCAL_SEARCH_EVENT, dataToLocalSearch);
	} else {
		helper.setLocalData(`${this.$attrs.name}::search`, this.search);
		this.$emit(SEARCH_EVENT, this.search);
	}
}

function onDragEnter(row) {
	this.$emit(ON_DRAG_ENTER, row);
}

function onDragLeave(row) {
	this.$emit(ON_DRAG_LEAVE, row);
}

function onDrop(row) {
	this.$emit(ON_DROP_EVENT, row);
}

function onDrag(row) {
	this.$emit(ON_DRAG_EVENT, row);
}

function changePage(page) {
	if (page !== '...') {
		if (page !== this.currentPage) {
			this.$emit(ON_PAGE_EVENT, page);
		}
	}
}

function cleanSearch(val) {
	if (val) {
		this.search = '';
	}
}

function selectPage(page) {
	let newPage = page > this.lastPage ? this.lastPage : page;
	newPage = newPage <= 0 ? 1 : newPage;
	changePage.call(this, Number(newPage));
}

function selectLastPage() {
	changePage.call(this, this.lastPage);
}

function tableOption() {
	const action = {
		active: true,
		code: 'filter-by',
		color: '#fafafa',
		imgSrc: '/static/img/actions-list/cancel.svg',
		open: true,
		title: 'FILTRAR POR',
		width: 229,
	};
	this.$emit(TABLE_OPTION_EVENT, action);
}

function createAction() {
	this.$emit('create-action');
}

function openDeleteSeat() {
	const action = {
		active: true,
		code: 'delete-seat',
		color: '#fafafa',
		imgSrc: 'https://japi-static.s3.amazonaws.com/japi-sales-error/behind.png',
		open: true,
		title: 'Eliminar Asiento',
		width: 300,
	};
	this.$emit('delete-seat', action);
}

function optionsDirection() {
	if (window.innerWidth < 768) {
		this.direction = 'center';
	} else {
		this.direction = 'right';
	}
}

function totalVisibleColumns() {
	return this.columns.filter(c => c.visible).length + 1;
}

function pages() {
	return pagination(this.currentPage, this.lastPage);
}

function tableClearFilter() {
	this.$emit(TABLE_CLEAR_FILTER);
}

export default {
	name: 'app-table',
	components,
	computed: {
		pages,
		totalVisibleColumns,
		checkedColumnsCount,
		selectableColumnsCount,
		ghostButtonStyle,
		mainButtonStyle,
	},
	data,
	created,
	methods: {
		addOption,
		addAIconAction,
		createAction,
		openDeleteSeat,
		onDrag,
		optionStyle,
		boxStyle,
		nameStyle,
		toggleAllColumns,
		onDragEnter,
		onDragLeave,
		onDrop,
		optionsDirection,
		rowIsSelected,
		searchRows,
		selectedAll,
		selectPage,
		selectLastPage,
		tableOption,
		toggleColumns,
		tableClearFilter,
	},
	mounted,
	props: {
		addButton: {
			default: false,
			type: Boolean,
		},
		captionQuantity: {
			default: true,
			type: Boolean,
		},
		itemsQuantity: [Number, String],
		title: [Number, String],
		itemsTotalQuantity: [Number, String],
		checkAll: {
			type: Boolean,
			default: false,
		},
		columns: {
			type: Array,
			required: true,
		},
		action: {
			default: false,
			type: Boolean,
		},
		flagTitle: {
			default: false,
			type: Boolean,
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		dispatchDetail: {
			default: false,
			type: Boolean,
		},
		filterColumns: {
			default: true,
			type: Boolean,
		},
		hideSelectableOnMovil: {
			default: false,
			type: Boolean,
		},
		includeFilter: {
			type: Boolean,
			default: false,
		},
		inputSearch: {
			default: true,
			type: Boolean,
		},
		localSearch: {
			type: Boolean,
			default: false,
		},
		localStorage: {
			type: Boolean,
			default: false,
		},
		rows: {
			type: Array,
			required: true,
		},
		selectable: {
			type: Boolean,
			default: false,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		keyValue: {
			type: String,
			default: 'id',
		},
		mainList: {
			type: Boolean,
			default: true,
		},
		cleanSearch: {
			default: false,
			type: Boolean,
		},
		detailSeat: {
			default: false,
			type: Boolean,
		},
		deleteSeat: {
			default: false,
			type: Boolean,
		},
		editCont: {
			default: false,
			type: Boolean,
		},
		showNewSeat: {
			default: false,
			type: Boolean,
		},
		showDetailSeat: {
			default: false,
			type: Boolean,
		},
		nameTooltip: {
			type: String,
			default: '',
		},
		addIcon: {
			type: Boolean,
			default: false,
		},
		tooltipDelete: {
			type: String,
			default: '',
		},
		clearFilter: {
			default: false,
			type: Boolean,
		},
		showAccounting: {
			type: Boolean,
			default: false,
		},
		showTableAccounting: {
			type: Boolean,
			default: false,
		},
		rowsDetails: {
			type: Array,
			default: () => [],
		},
		showRecord: {
			type: Boolean,
			default: false,
		},
		disabledEditAccou: {
			type: Boolean,
			default: true,
		},
		accountName: {
			default: null,
			type: String,
		},
		createdAdd: {
			type: Boolean,
			default: true,
		},
		numberSeats: {
			type: Number,
			default: 0,
		},
		tFoot: {
			type: Boolean,
			default: true,
		},
		showExcel: {
			type: Boolean,
			default: false,
		},
		height: {
			type: Number,
			default: 18,
		},
		downButton: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		cleanSearch,
	},
};

</script>

<style lang="scss" scoped>
/* =============================================================
   app-table  ·  bloque <style lang="scss" scoped> completo
   Reemplaza el actual. No cambia ninguna clase ni selector que
   usen las pantallas: solo cambian los valores visuales.
   ============================================================= */

$tb-ink: #16222b;
$tb-ink-2: #3d4b55;
$tb-muted: #90a0aa;
$tb-line: #edf1f3;
$tb-border: #dde5e9;
$tb-plane: #fafcfc;
$tb-teal: #02979b;
$tb-teal-dark: #017e82;
$tb-teal-soft: #e8f5f5;

input {
	background-color: transparent;
	border-style: none;
}

table.table-list {
	background-color: #ffffff;
	border: 1px solid $tb-border;
	border-collapse: separate;
	border-radius: 12px;
	border-spacing: 0;
	box-shadow: 0 1px 2px rgba(22, 34, 43, 0.04), 0 8px 24px rgba(22, 34, 43, 0.05);
	font-family: "AvenirRegular" !important;
	overflow: hidden;
	width: 100%;

	thead {
		background-color: $tb-teal !important;
		color: #ffffff;
		font-size: 12px;

		th {
			align-items: center;
			font-family: map-get($fonts, opens-semibold);
			font-size: 10px;
			font-weight: 700;
			height: 34px;
			letter-spacing: 0.7px;
			padding: 0 10px;
			position: relative;
			text-align: center;
			text-transform: uppercase;
			white-space: nowrap;

			@media (max-width: 768px) {
				height: 35px;
				overflow: auto;
				padding: 10px 5px 0;
			}

			&:first-child {
				padding-left: 14px;
				text-align: left;
			}

			.check-list {
				margin-top: -1px !important;
			}
		}

		/* fila de herramientas (buscador, filtros, botones) */
		tr:first-child {
			th {
				background-color: $tb-teal-dark;
				height: 42px;
				letter-spacing: normal;
				text-transform: none;

				&:last-child {
					padding-right: 12px;
				}
			}
		}

		button {
			align-items: center;
			background-color: rgba(255, 255, 255, 0.18);
			border: 0;
			border-radius: 50%;
			display: inline-flex;
			height: 26px;
			justify-content: center;
			line-height: 22px;
			margin-left: 4px;
			outline: none;
			transition: background-color 0.15s;
			width: 26px;

			&:hover {
				background-color: rgba(255, 255, 255, 0.3);
			}

			.v-icon {
				font-size: 16px !important;
			}

			.icon {
				color: white;
				height: 20px;
				line-height: 19px;
			}
		}

		.btn-clean-filter-add {
			background-color: #0a4df6 !important;
			border-radius: 8px;
			color: map-get($colors, white);
			font-weight: 700;
			left: 10px;
			padding: 0 10px;
			position: absolute;
			width: 128px;

			@media (max-width: 768px) {
				top: 2px;
			}
		}

		.btn-clean-filter {
			background-color: rgba(255, 255, 255, 0.18);
			border-radius: 8px;
			color: map-get($colors, white);
			font-size: 11px;
			font-weight: 700;
			height: 26px;
			padding: 0 12px;
			width: auto;

			&:hover {
				background-color: rgba(255, 255, 255, 0.3);
			}
		}

		.btn-filter {
			background-color: rgba(255, 255, 255, 0.18);
			border-radius: 8px;
			color: map-get($colors, white);
			font-size: 11px;
			font-weight: 700;
			height: 26px;
			padding: 0 12px;
			width: auto;

			&:hover {
				background-color: rgba(255, 255, 255, 0.3);
			}
		}
	}

	&.is-not-selectable {
		th {
			&:first-child {
				width: auto;
			}
		}
	}

	tbody {
		tr {
			color: $tb-ink-2;
			font-family: map-get($fonts, opens-semibold);
			font-size: 11.5px;
			transition: background-color 0.12s;

			&:nth-child(odd) {
				background: $tb-plane !important;

				@media (max-width: 768px) {
					background: white;
				}

				&.row-checked {
					background-color: $tb-teal-soft !important;
				}
			}

			&:nth-child(even) {
				background-color: white;
			}

			td {
				align-items: center;
				border-bottom: 1px solid $tb-line;
				height: 34px;
				padding: 0 10px;
				position: relative;
				text-align: center;
				width: auto;

				@media (max-width: 768px) {
					border-right: none !important;
					height: 43px;
					padding: 11px 0;
				}

				&:first-child:not(.is-not-selectable) {
					padding-left: 14px;
					text-align: left;
					width: 74px;
				}

				.check-list {
					margin-top: -1px !important;
				}

				.table-icon {
					img {
						vertical-align: middle;
					}

					&.btn {
						background-color: transparent;
						box-shadow: none;
						margin: 0px;
						min-width: auto;
					}
				}
			}

			/* el hover ya no cambia la altura de la fila */
			&:hover {
				background-color: #f2fafa !important;

				td:not(.td-employee) {
					color: $tb-ink;
				}
			}

			&:last-child {
				td {
					border-bottom: none;
				}
			}
		}

		/* fila seleccionada: tinte + barra lateral, sin saltos */
		tr.row-checked {
			background-color: $tb-teal-soft !important;
			color: $tb-ink;

			td {
				font-family: map-get($fonts, opens-bold);
			}

			td:first-child {
				box-shadow: inset 3px 0 0 $tb-teal;
			}
		}

		tr.is-select {
			td:not(.td-employee) {
				background-color: $tb-teal-soft;
				color: $tb-ink;
			}

			&-employee {
				td.td-employee {
					background-color: $tb-teal-soft;
					color: $tb-ink;
				}
			}
		}
	}

	tfoot {
		tr {
			td {
				background-color: white;
				border-top: 1px solid #e3e9ec;
				box-shadow: none;
				height: 40px;
				padding: 0 14px;

				a {
					border-radius: 7px;
					color: $tb-ink-2;
					cursor: pointer;
					display: inline-block;
					font-family: map-get($fonts, open-regular);
					font-size: 12px;
					font-weight: 700;
					line-height: 24px;
					margin-left: 3px;
					min-width: 24px;
					padding: 0 6px;
					text-align: center;
					transition: background-color 0.12s;

					& + span {
						color: $tb-muted;

						& + a {
							margin-left: 0px;
						}
					}

					&.active-page {
						background-color: $tb-teal;
						color: #ffffff;
					}

					/* antes crecia la fuente en hover y la fila bailaba */
					&:hover {
						background-color: #eef3f5;
					}
				}
			}
		}
	}

	&.no-main-list {
		border-bottom: 1px solid $tb-border;
	}

	.search-input {
		align-items: center;
		background-color: rgba(255, 255, 255, 0.16) !important;
		border: 1px solid rgba(255, 255, 255, 0.35) !important;
		border-radius: 999px !important;
		display: inline-flex;
		height: 26px;
		max-width: 210px;
		padding: 0 6px 0 12px;
		vertical-align: middle;
		width: 100%;

		input {
			color: #ffffff;
			font-size: 12px;
			outline: none;
			padding: 0;
			width: calc(100% - 24px);
		}

		.v-icon {
			align-self: center;
			color: rgba(255, 255, 255, 0.85) !important;
			font-size: 17px;
			/* el icono de lupa ya no sale girado */
			transform: none;
		}

		@media (max-width: 768px) {
			display: none;

			&.unique-input {
				width: 50px;
			}
		}
	}

	.checkbox {
		.icon {
			font-size: 14px;
		}

		.input-group--selection-controls__ripple {
			height: 15px;
			left: 13px;
			width: 15px;
		}
	}

	.input-checkbox {
		border: 1px solid map-get($colors, grey-border);
		border-radius: 3px;
		height: 15px;
		width: 15px;
	}
}

.caption-quantity {
	color: color(paginationText);
	font-family: font(open-semibold);
	font-size: size(medium);
	margin-right: 10px;
}

.unique-input {
	background-color: #ffffff;
	border: 1px solid $tb-border !important;
	border-radius: 7px !important;
	color: $tb-ink-2;
	height: 24px;
	margin-right: 6px;
	opacity: 1;
	padding: 0 6px;
	text-align: center;
	width: 46px;
}

.unique-input:focus-within {
	border-color: $tb-teal !important;
	opacity: 1;
}

.row-checked {
	background-color: $tb-teal-soft !important;
}

.v-menu .v-icon {
	color: map-get($colors, white) !important;
}

.vertical-align-middle {
	vertical-align: middle;
}

.column-movil-version {
	@media (max-width: 768px) {
		display: none;
	}
}

tr.movil-table {
	@media (max-width: 768px) {
		align-items: center;
		display: grid;
		font-size: size(small11) !important;
		grid-template-columns: repeat(auto-fit, minmax(20px, 1fr));

		.hide-selectable-on-movil {
			display: none;
		}

		td {
			overflow: hidden;
		}
	}
}

th.movil-header-row {
	@media (max-width: 768px) {
		display: none;
	}
}

.check-row {
	@media (max-width: 768px) {
		display: flex;
		grid-column: 1 / 2;
		grid-row: 1;
		justify-content: flex-start;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: auto !important;
	}
}

.btn-add {
	left: 10px;
	position: absolute;

	@media (max-width: 768px) {
		top: 2px;
	}
}

.btn-delete {
	left: 148px;
	position: absolute;
	top: 7px;
}

.btn-add-mobile {
	display: none;

	@media (max-width: 768px) {
		background-color: map-get($colors, secondary) !important;
		border-radius: 8px !important;
		box-shadow: none !important;
		color: map-get($colors, white);
		display: block;
		font-size: 25px;
		height: 35px !important;
		margin-left: auto !important;
		padding: 0 !important;
		text-transform: none !important;
		width: 41px !important;
	}
}

.absolute-btn {
	display: none;

	@media (max-width: 768px) {
		display: block;
		padding: 0 !important;
	}
}

.background-table {
	background-color: #33cfc7;
	opacity: 0.12;
}

.background-blue-table {
	background-color: #006edb;
	opacity: 0.12;
}

.show-record {
	border: 1.5px dashed #bfe3e4;
	border-radius: 10px;
	color: #5b6b76;
	font-family: map-get($fonts, AvenirRegular);
	font-size: 14px;
	margin: 0 auto;
	max-width: 420px;
	padding: 20px 28px;
	text-align: center;
}

.td-record {
	background-color: #ffffff;
	padding: 90px 0 100px;
}

.empty-message {
	color: $tb-muted;
	font-family: map-get($fonts, AvenirRegular);
	font-size: 13px;
	margin: 0;
	padding: 28px 0;
	text-align: center;
}

.should-color {
	background-color: $tb-teal !important;
	border-radius: 8px;
	height: 31px;

	@media (max-width: 768px) {
		font-size: 11px;
		width: 194px;
	}

	.debitV {
		color: white;
		font-family: 'AvenirRegular';
		font-size: 14px;
		font-stretch: normal;
		font-style: normal;
		font-weight: bold;
		height: 20px;
		letter-spacing: normal;
		line-height: 1.54;
		text-align: center;
		width: 174px;
	}
}

.btn-edit {
	border-radius: 8px !important;
	color: white !important;
	font-family: map-get($fonts, AvenirDemi);
	font-size: 10px;
	left: 15px;
	position: absolute;
	top: 7px;
	width: 49px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/table/app-table.vue